var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"canvas-container",staticClass:"canvas-container"}),_c('button',{on:{"click":_vm.toggleCameraMode}},[_vm._v("Toggle Camera View - "+_vm._s(_vm.cameraMode))])])}
var staticRenderFns = []

export { render, staticRenderFns }